import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

interface FinalCTASectionProps {
  isLoggedIn: boolean;
  onStartTraining: () => void;
}

const FinalCTASection: React.FC<FinalCTASectionProps> = ({
  isLoggedIn,
  onStartTraining,
}) => {
  return (
    <section className="py-16 bg-gradient-to-r from-blue-600 to-purple-600 relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-20 h-20 border border-white/20 rounded-full animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 border border-white/20 rounded-lg rotate-45 animate-bounce"></div>
        <div className="absolute top-1/2 left-1/4 w-12 h-12 border border-white/20 rounded-full animate-ping"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6">
          <Sparkles className="w-4 h-4 mr-2" />
          开始你的思维提升之旅
        </div>

        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
          准备好提升你的思维能力了吗？
        </h2>

        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
          加入数千名用户，通过AI驱动的训练方法，系统性地提升你的逻辑思维、创意思维和表达能力。
        </p>

        <button
          onClick={onStartTraining}
          className="group bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-gray-50 hover:scale-105 transition-all duration-300 shadow-2xl inline-flex items-center"
        >
          {isLoggedIn ? '继续学习' : '立即开始免费体验'}
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
        </button>

        <p className="text-blue-100 text-sm mt-4">
          免费试用 • 无需信用卡 • 随时取消
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;